module.exports = __webpack_public_path__ + "img/bmw-partnership-mobile.jpg";